import { useState } from 'react';
import { Card } from 'react-bootstrap';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Captions from 'yet-another-react-lightbox/plugins/captions';

import './ImageGalleryCard.css';

// Updated to avoid conflict with global Image object
export type GalleryImageItem = {
  thumbnail: string;
  title: string;
  src: string;
};

type ImageGalleryCardProps = {
  images: GalleryImageItem[];
  footerText?: string;
  className?: string;
};

export const ImageGalleryCard = ({
  images,
  footerText = 'VIEW HIGHLIGHTS',
  className = '',
}: ImageGalleryCardProps) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      setLightboxOpen(true);
    }
  };

  return (
    <>
      <div
        className={`image-gallery-card-link ${className}`}
        onClick={() => setLightboxOpen(true)}
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <Card className="image-gallery-card">
          <div className="image-gallery-image-stack">
            {images.slice(0, 3).map((img, index) => (
              <img
                key={index}
                src={img.thumbnail}
                alt={img.title}
                className={`image-gallery-thumbnail stacked stacked-${index}`}
              />
            ))}
          </div>
          <Card.Footer className="image-gallery-footer">
            {footerText}
          </Card.Footer>
        </Card>
      </div>

      {/* Lightbox OUTSIDE container for proper centering */}
      {lightboxOpen && (
        <Lightbox
          open
          close={() => setLightboxOpen(false)}
          slides={images.map((img) => ({
            src: img.src,
            title: img.title,
          }))}
          plugins={[Thumbnails, Captions]}
        />
      )}
    </>
  );
};

export default ImageGalleryCard;
